import React from 'react'
import url from 'libraries/front-end-core/core/url'
import { UTILS } from 'constants/controllers'
import cx from 'classnames'
import { useSelector } from 'react-redux'
import selectAolName from 'redux/selectors/selectAolName'

const Header = ({ view }) => {
  const aol = useSelector(selectAolName)

  return (
    <div className='account-navigation persist'>
      <ul>
        <li role='presentation' className={cx({ active: view === 'icons' })}>
          <a href={url(UTILS, { aol, view: 'icons' })}>Icons</a>
        </li>
      </ul>
    </div>
  )
}

export default Header
